module.exports = __webpack_public_path__ + "img/edition.e3a49ab4.svg";